<template>
  <b-container
    id="payment-success-page"
    class="d-flex flex-column align-items-center justify-content-center"
    v-if="orderDetails"
  >
    <b-row id="contents">
      <b-col md="6" lg="4" class="mx-auto">
        <b-row>
          <b-col class="text-center">
            <img src="@/assets/images/img-success.png" alt="Success" />
            <div class="h2 mt-4">Payment being processed</div>
            <div class="mt-3 mb-4">
              Please wait while we confirm your payment
            </div>
            <hr />
          </b-col>
        </b-row>
        <b-row class="mb-2">
          <b-col> Transaction ID </b-col>
          <b-col class="font-weight-bold">
            {{ orderDetails.transaction_no }}
          </b-col>
        </b-row>
        <b-row>
          <b-col> Amount Paid </b-col>
          <b-col class="font-weight-bold"
            >&#8369;{{ orderDetails.computed_total | currency }}</b-col
          >
        </b-row>
      </b-col>
    </b-row>
    <b-row id="button-container" class="mt-5">
      <b-col md="6" lg="4" class="mx-auto">
        <b-button
          class="btn btn-core border-0 text-uppercase"
          block
          @click="onProceedSuccess"
          :style="{
            backgroundColor: `${design.main_color} !important`,
            color: `${design.button_text_color} !important`
          }"
        >
          View Order Details
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "PaymentSuccess",
  computed: {
    ...mapState("merchant", ["customerPortalToken"]),
    ...mapState("estore", ["orderDetails"]),
    ...mapGetters("estore", ["design"]),
    ...mapGetters("customer", ["customerToken"])
  },
  filters: {
    currency(value) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  methods: {
    async getOrderDetails(id) {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken
        },
        tracking_uuid: id
      };
      await this.$store.dispatch("estore/getOrderDetails", request);

      if (!this.orderDetails) this.$router.push({ name: "404" });
    },
    onProceedSuccess() {
      this.$router.push({
        name: "Orders",
        params: { order_id: this.orderDetails.uuid }
      });
    },
    postMessage(message) {
      if (window.webkit && window.webkit.messageHandlers.appInterface)
        window.webkit.messageHandlers.appInterface.postMessage(message);

      if (window.appInterface) window.appInterface.postMessage(message);
    }
  },
  created() {
    this.postMessage("Payment Successful");

    const { orderId } = this.$route.query;

    if (!orderId) {
      this.$router.push({ name: "404" });

      return;
    }

    this.getOrderDetails(orderId);
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/views/checkout/_payment-success.scss";
</style>
